import { handleActions } from 'redux-actions';
import * as types from './constants';

export let NomineeState = {
    isLoading: false,
    lastDeleted: null
};

export default handleActions(
    {
        [types.DELETE_NOMINEE]: (state = NomineeState, action) => ({
            isLoading: false,
            lastDeleted: action.payload
        }),

        [types.LOADING_STATUS]: (state = NomineeState, action) => ({
            ...state,
            isLoading: action.payload
        })
    },
    NomineeState
);
